import ModuleReviewForm from 'shared/components/molecules/ModuleReviewForm/ModuleReviewForm';

export default ModuleReviewForm;
